@use "variables" as *;

.mainDiv {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.visits {
  font-size: $fontSize-s;
  font-weight: normal;
  padding: $spacing-xs;
}
